import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import SeatDetail from './SeatDetail';
import { CreateUpdateSeatingModelDetailModel, CompanyTicketClassDto } from '@/__generated';
type Props = {
  seatKey: string;
  data: CreateUpdateSeatingModelDetailModel | null | undefined;
  removeSeat: (key: string) => void;
  onChange: (key: string, seat: CreateUpdateSeatingModelDetailModel) => void;
  ticketClasses: CompanyTicketClassDto[];
};

export default function DroppableSeat({ data, onChange, ticketClasses, removeSeat, seatKey }: Props) {
  const { setNodeRef, isOver } = useDroppable({
    id: seatKey,
    disabled: !!data,
  });
  const style = isOver ? { backgroundColor: '#dddddd80' } : undefined;
  return (
    <div className="col bus-seat-item" ref={setNodeRef} style={style} data-key={seatKey} data-allowselect={data ? null : 1}>
      {data ? <SeatDetail seat={data} onRemove={removeSeat} onChange={onChange} ticketClasses={ticketClasses} /> : null}
    </div>
  );
}
